import { render, staticRenderFns } from "./Base500Black.vue?vue&type=template&id=7d1f8015&scoped=true&"
var script = {}
import style0 from "./Base500Black.vue?vue&type=style&index=0&id=7d1f8015&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d1f8015",
  null
  
)

export default component.exports